/**
 * Cor de fundo da seção (row) — mesmo critério no palco, visualizar e exportar.
 */
export function resolveRowBackgroundColor(config) {
    const c = config || {};
    const bg = c.backgroundColor;
    if (bg != null && String(bg).trim() && bg !== 'transparent') return String(bg).trim();
    if (c.computedBgRGBA && c.computedBgRGBA !== 'transparent') return c.computedBgRGBA;
    if (c.wrapperBg && c.wrapperBg !== 'transparent') return c.wrapperBg;
    return 'transparent';
}
